import * as actionTypes from "Redux/Actions/actionTypes";

const getAccount = (callback = () => {}) => ({
  type: actionTypes.GET_ACCOUNT,
  callback,
});

export default getAccount;
